import { useParams, Link } from 'react-router-dom';
import { newsArticles } from '@/mocks/news';

export default function ArticleGrid() {
  const { slug } = useParams<{ slug: string }>();
  const filtered = newsArticles.filter((a) => a.categorySlug === slug);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-6 md:px-10">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-10">
          全部内容
        </h2>

        {filtered.length === 0 ? (
          <p className="text-center text-foreground-400 text-sm py-20">暂无相关内容</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
            {filtered.map((article, idx) => (
              <Link
                key={article.id}
                to={`/detail/${article.id}`}
                className="group bg-background-100 border border-foreground-200/15 rounded-xl overflow-hidden transition-all duration-300 hover:border-primary-500/40 cursor-pointer"
              >
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    title={`${article.title} - 51黑料吃瓜网`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                  {article.isFeatured && (
                    <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-bold rounded-md bg-primary-500 text-foreground-950">
                      HOT
                    </span>
                  )}
                </div>
                <div className="p-5">
                  <h3 className="font-heading font-bold text-foreground-800 text-base leading-snug group-hover:text-primary-400 transition-colors duration-300 line-clamp-2 mb-2">
                    {article.title}
                  </h3>
                  <p className="text-foreground-400 text-sm line-clamp-2 mb-4 leading-relaxed">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-foreground-400 text-xs">
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line"></i> {article.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}